import React from 'react';

interface ConditionalWrapperProps {
  if: boolean;
  componentA: React.ElementType | (() => JSX.Element);
  componentB: React.ElementType | (() => JSX.Element);
  [x: string]: any;
}

const ConditionalWrapper = React.forwardRef<
  HTMLElement,
  ConditionalWrapperProps
>(
  (
    { if: condition, componentA: ComponentA, componentB: ComponentB, ...props },
    ref,
  ) => {
    const Component = condition ? ComponentA : ComponentB;
    return <Component ref={ref} {...props} />;
  },
);

export default ConditionalWrapper;
